import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { RootState } from '../../modules';

import { TEXT_TEMPLATE } from '../../constants';
import { setMarkedToolbar } from '../../modules/editor';
import AddContent from './AddContent';
import CommonStyle from './CommonStyle';
import SelectedContent from './SelectedContent';


function SidebarContainer({ showBaseSidebar, showSelectedSidebar }) {
	const [currentTab, setCurrentTab] = useState(0);
	const dispatch = useDispatch();

	const markToolbarInit = () => {
		dispatch(setMarkedToolbar({
			contentId: -1,
			currentIndex: -1,
			itemType: ''
		}))
	}

	const selectedContentId = useSelector((state: RootState) => state.editor.selectedContentId);
	const contents = useSelector((state: RootState) => state.editor.contents);
	const { templateId } = useSelector((state: RootState) => state.editor.email);


	const currentContent = contents?.find((item) => {
		return item.id === selectedContentId;
	})

	const toggleTab = (index: number) => {
		setCurrentTab(index);
	}

	return (
		<div className={
			(templateId !== TEXT_TEMPLATE && showBaseSidebar) ? "editor-sidebar" : "editor-sidebar hided"}
			onClick={markToolbarInit}>
			<ul className="editor-sidebar-tab">
				<li className={currentTab === 0 ? 'active' : ''}>
					<button onClick={() => toggleTab(0)}>상자</button>
				</li>
				<li className={currentTab === 1 ? 'active' : ''}>
					<button onClick={() => toggleTab(1)}>스타일</button>
				</li>
			</ul>
			{
				(currentTab === 0 && selectedContentId === -1) && (<AddContent />)
			}
			{
				(currentTab === 1 && selectedContentId === -1) && (<CommonStyle />)
			}			
			<SelectedContent showSelectedSidebar={showSelectedSidebar} />
		</div>
	);
}

export default SidebarContainer;